function RequisiteSpacing(props){
    const NAV_BAR_HEIGHT = props.NAV_BAR_HEIGHT

    return (
        <div style={{height: `${NAV_BAR_HEIGHT}`}}></div>
    )
}

export default RequisiteSpacing